// import { useNavigate } from "react-router-dom";

import "./Footer.css";
import Logo from "../../assets/logo.png";

const Footer = () => {
  const social = (e) => {
    // console.log(e);
    if (e === "facebook") {
      window.open("https://www.facebook.com/inder.dhami.73?mibextid=ZbWKwL");
    }
    if (e === "instagram") {
      window.open("https://www.instagram.com/fitness_comando_dhami/");
    }
    if (e === "whatsapp") {
      window.open("https://api.whatsapp.com/send?phone=917071808888");
    }
    if (e === "gmail") {
      window.open("mailto:pro39gym@gmail.com");
    }
  };

  return (
    <div className="footer-container">
      <hr />
      <div className="footer">
        <div className="social-links">
          <svg
            id="facebook"
            onClick={(e) => {
              social("facebook");
            }}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28.6895 22.2136L29.726 15.3883H23.242V10.9612C23.242 9.09345 24.1461 7.27184 27.0502 7.27184H30V1.46117C30 1.46117 27.3242 1 24.7671 1C19.4247 1 15.9361 4.26966 15.9361 10.1864V15.3883H10V22.2136H15.9361V38.7141C17.1279 38.9032 18.347 39 19.589 39C20.8311 39 22.0502 38.9032 23.242 38.7141V22.2136H28.6895Z"
              fill="black"
            />
          </svg>
          <svg
            id="instagram"
            onClick={(e) => {
              social("instagram");
            }}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_5_186)">
              <path
                d="M20 3.6046C25.3434 3.6046 25.9706 3.62842 28.0826 3.7237C30.0358 3.81104 31.0917 4.13656 31.7984 4.41445C32.7352 4.77967 33.4022 5.20842 34.1009 5.90711C34.7995 6.6058 35.2362 7.27273 35.5935 8.20961C35.8635 8.91624 36.1969 9.97221 36.2843 11.9254C36.3795 14.0373 36.4034 14.6645 36.4034 20.0079C36.4034 25.3513 36.3795 25.9786 36.2843 28.0905C36.1969 30.0437 35.8714 31.0996 35.5935 31.8063C35.2283 32.7432 34.7995 33.4101 34.1009 34.1088C33.4022 34.8075 32.7352 35.2441 31.7984 35.6014C31.0917 35.8714 30.0358 36.2048 28.0826 36.2922C25.9706 36.3875 25.3434 36.4113 20 36.4113C14.6566 36.4113 14.0294 36.3875 11.9174 36.2922C9.96428 36.2048 8.9083 35.8793 8.20167 35.6014C7.26479 35.2362 6.59786 34.8075 5.89917 34.1088C5.20048 33.4101 4.7638 32.7432 4.40651 31.8063C4.13657 31.0996 3.8031 30.0437 3.71576 28.0905C3.62049 25.9786 3.59667 25.3513 3.59667 20.0079C3.59667 14.6645 3.62049 14.0373 3.71576 11.9254C3.8031 9.97221 4.12863 8.91624 4.40651 8.20961C4.77174 7.27273 5.20048 6.6058 5.89917 5.90711C6.59786 5.20842 7.26479 4.77173 8.20167 4.41445C8.9083 4.1445 9.96428 3.81104 11.9174 3.7237C14.0294 3.62048 14.6646 3.6046 20 3.6046ZM20 0C14.5693 0 13.8865 0.023819 11.7507 0.119095C9.62287 0.214371 8.16991 0.555776 6.89957 1.04803C5.58158 1.55617 4.47003 2.24692 3.35848 3.35848C2.24692 4.47003 1.56411 5.58952 1.04804 6.89956C0.555776 8.16991 0.214371 9.62287 0.119095 11.7586C0.023819 13.8865 0 14.5693 0 20C0 25.4307 0.023819 26.1135 0.119095 28.2493C0.214371 30.3771 0.555776 31.8301 1.04804 33.1084C1.55617 34.4264 2.24692 35.5379 3.35848 36.6495C4.47003 37.761 5.58952 38.4438 6.89957 38.9599C8.16991 39.4522 9.62287 39.7936 11.7586 39.8888C13.8944 39.9841 14.5693 40.0079 20.008 40.0079C25.4466 40.0079 26.1215 39.9841 28.2573 39.8888C30.3851 39.7936 31.8381 39.4522 33.1163 38.9599C34.4343 38.4518 35.5459 37.761 36.6574 36.6495C37.769 35.5379 38.4518 34.4184 38.9679 33.1084C39.4601 31.838 39.8015 30.3851 39.8968 28.2493C39.9921 26.1135 40.0159 25.4387 40.0159 20C40.0159 14.5613 39.9921 13.8865 39.8968 11.7507C39.8015 9.62287 39.4601 8.16991 38.9679 6.89162C38.4597 5.57364 37.769 4.46209 36.6574 3.35054C35.5459 2.23898 34.4264 1.55617 33.1163 1.0401C31.846 0.547836 30.393 0.206431 28.2573 0.111155C26.1136 0.023819 25.4307 0 20 0Z"
                fill="black"
              />
              <path
                d="M20 9.73401C14.3311 9.73401 9.72607 14.3311 9.72607 20.0079C9.72607 25.6848 14.3231 30.2818 20 30.2818C25.6768 30.2818 30.2739 25.6848 30.2739 20.0079C30.2739 14.3311 25.6768 9.73401 20 9.73401ZM20 26.6693C16.316 26.6693 13.3307 23.684 13.3307 20C13.3307 16.316 16.316 13.3307 20 13.3307C23.684 13.3307 26.6693 16.316 26.6693 20C26.6693 23.684 23.684 26.6693 20 26.6693Z"
                fill="black"
              />
              <path
                d="M30.6788 11.7189C32.0031 11.7189 33.0766 10.6454 33.0766 9.32115C33.0766 7.99689 32.0031 6.92337 30.6788 6.92337C29.3546 6.92337 28.2811 7.99689 28.2811 9.32115C28.2811 10.6454 29.3546 11.7189 30.6788 11.7189Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_5_186">
                <rect width="40" height="40" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <svg
            id="whatsapp"
            onClick={(e) => {
              social("whatsapp");
            }}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="40" height="40" rx="20" fill="black" />
            <path
              d="M7.86816 31.6334L9.58305 25.4061C8.52283 23.5783 7.96665 21.5083 7.97245 19.3921C7.97245 12.7612 13.3952 7.37 20.052 7.37C23.2848 7.37 26.3206 8.62122 28.5975 10.893C30.8801 13.1648 32.1373 16.1862 32.1315 19.3979C32.1315 26.0288 26.7088 31.42 20.0462 31.42H20.0404C18.0185 31.42 16.0313 30.9126 14.2642 29.9555L7.86816 31.6334ZM14.5713 27.7817L14.9363 28.0008C16.4774 28.9118 18.2444 29.3904 20.0462 29.3962H20.052C25.5848 29.3962 30.0922 24.916 30.0922 19.4037C30.0922 16.734 29.0494 14.2258 27.1549 12.3345C25.2604 10.4433 22.7344 9.4054 20.052 9.4054C14.5192 9.39963 10.0118 13.8798 10.0118 19.3921C10.0118 21.2776 10.539 23.117 11.5471 24.7084L11.7846 25.089L10.7707 28.7734L14.5713 27.7817Z"
              fill="white"
            />
            <path
              d="M8.29102 31.2125L9.94797 25.1985C8.92251 23.4399 8.38371 21.4391 8.38371 19.3979C8.38951 12.9976 13.6211 7.79092 20.0519 7.79092C23.1746 7.79092 26.1004 9.00179 28.3019 11.1929C30.5035 13.384 31.7143 16.3016 31.7143 19.4037C31.7143 25.804 26.477 31.0107 20.0519 31.0107H20.0461C18.0937 31.0107 16.176 30.5206 14.4727 29.598L8.29102 31.2125Z"
              fill="black"
            />
            <path
              d="M7.86816 31.6334L9.58305 25.4061C8.52283 23.5783 7.96665 21.5083 7.97245 19.3921C7.97245 12.7612 13.3952 7.37 20.052 7.37C23.2848 7.37 26.3206 8.62122 28.5975 10.893C30.8801 13.1648 32.1373 16.1862 32.1315 19.3979C32.1315 26.0288 26.7088 31.42 20.0462 31.42H20.0404C18.0185 31.42 16.0313 30.9126 14.2642 29.9555L7.86816 31.6334ZM14.5713 27.7817L14.9363 28.0008C16.4774 28.9118 18.2444 29.3904 20.0462 29.3962H20.052C25.5848 29.3962 30.0922 24.916 30.0922 19.4037C30.0922 16.734 29.0494 14.2258 27.1549 12.3345C25.2604 10.4433 22.7344 9.4054 20.052 9.4054C14.5192 9.39963 10.0118 13.8798 10.0118 19.3921C10.0118 21.2776 10.539 23.117 11.5471 24.7084L11.7846 25.089L10.7707 28.7734L14.5713 27.7817Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.0334 14.3642C16.8075 13.8625 16.5699 13.851 16.3556 13.8452C16.1818 13.8395 15.979 13.8395 15.7762 13.8395C15.5735 13.8395 15.249 13.9144 14.9709 14.2143C14.6928 14.5141 13.9165 15.2406 13.9165 16.7225C13.9165 18.1986 14.9999 19.6286 15.1505 19.8304C15.3012 20.0322 17.242 23.1631 20.3068 24.3682C22.8559 25.3715 23.3774 25.1697 23.9278 25.1178C24.4781 25.0659 25.7122 24.3913 25.9671 23.6878C26.2162 22.9844 26.2162 22.3847 26.1409 22.2579C26.0656 22.131 25.8628 22.056 25.5615 21.9061C25.2603 21.7562 23.7771 21.0297 23.499 20.9259C23.2209 20.8279 23.0182 20.776 22.8212 21.0758C22.6184 21.3757 22.0391 22.0503 21.8652 22.2521C21.6914 22.4539 21.5118 22.477 21.2106 22.3271C20.9093 22.1771 19.936 21.86 18.7831 20.8337C17.8851 20.0379 17.2768 19.052 17.103 18.7521C16.9291 18.4523 17.0856 18.2908 17.2362 18.1409C17.3695 18.0083 17.5375 17.7892 17.6881 17.6162C17.8387 17.4432 17.8909 17.3164 17.9894 17.1146C18.0879 16.9128 18.0415 16.7398 17.9662 16.5899C17.8909 16.4457 17.2999 14.9581 17.0334 14.3642Z"
              fill="white"
            />
          </svg>
          <svg
            id="gmail"
            onClick={(e) => {
              social("gmail");
            }}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_9_561)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39.2 20.4546C39.2 19.0364 39.0727 17.6727 38.8364 16.3636H20V24.1H30.7636C30.3 26.6 28.8909 28.7182 26.7727 30.1364V35.1546H33.2364C37.0182 31.6727 39.2 26.5455 39.2 20.4546Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 40C25.4 40 29.9273 38.2091 33.2364 35.1545L26.7728 30.1364C24.9819 31.3364 22.691 32.0454 20 32.0454C14.791 32.0454 10.3819 28.5273 8.80914 23.8H2.12732V28.9818C5.41823 35.5182 12.1819 40 20 40Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.80909 23.8C8.40909 22.6 8.18182 21.3182 8.18182 20C8.18182 18.6818 8.40909 17.4 8.80909 16.2V11.0182H2.12727C0.772727 13.7182 0 16.7727 0 20C0 23.2273 0.772727 26.2818 2.12727 28.9818L8.80909 23.8Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 7.95455C22.9364 7.95455 25.5728 8.96364 27.6455 10.9455L33.3819 5.20909C29.9182 1.98182 25.391 0 20 0C12.1819 0 5.41823 4.48182 2.12732 11.0182L8.80914 16.2C10.3819 11.4727 14.791 7.95455 20 7.95455Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_9_561">
                <rect width="40" height="40" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className="logo-f">
          <img src={Logo} alt="" />
        </div>
      </div>
      <div className="blur blur-f-1"></div>
      <div className="blur blur-f-2"></div>
    </div>
  );
};

export default Footer;
